export default __webpack_public_path__ + "images/7I.e750ad9.png";